import { render, staticRenderFns } from "./inetW2.vue?vue&type=template&id=3c9b5060&scoped=true"
import script from "./inetW2.vue?vue&type=script&lang=js"
export * from "./inetW2.vue?vue&type=script&lang=js"
import style0 from "./inetW2.vue?vue&type=style&index=0&id=3c9b5060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b5060",
  null
  
)

export default component.exports